import { render } from "./ServiceCalendar.vue?vue&type=template&id=7f53d49f&scoped=true"
import script from "./ServiceCalendar.vue?vue&type=script&lang=js"
export * from "./ServiceCalendar.vue?vue&type=script&lang=js"

import "./ServiceCalendar.vue?vue&type=style&index=0&id=7f53d49f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f53d49f"]])

export default __exports__